module.exports = __webpack_public_path__ + "img/Spain.eba6b92b.png";